export const frontUrl = "https://ceofront.iosx.in"
export default frontUrl;

export const BASE_URL = "https://ceo.iosx.in/api/";
